module.exports = __webpack_public_path__ + "static/media/Matthew.d8a9f91d.jpg";